import { DownloadActions } from '@app/components/DownloadActions';
import { getIsProductSortingEnabled } from '@app/ducks/config';
import { useAmplitude } from '@app/utils/analytics/useAmplitude';
import { Sorting } from '@typings';
import React from 'react';
import { useSelector } from 'react-redux';

import { useAllProductsContext } from '../context/AllProductsContext';
import { ProductSorting } from '../ProductSorting';

import { ProductsContentSwitcher } from './ProductsContentSwitcher';

export const ProductsActions = () => {
  const isProductSortingEnabled = useSelector(getIsProductSortingEnabled);
  const { trackEvent } = useAmplitude();
  const { changeSort } = useAllProductsContext();

  const handleSortingChange = React.useCallback(
    (value: Sorting.FieldValue) => {
      changeSort(value);
      trackEvent({ name: 'listing.select.sortby', properties: { sortBy: value } });
    },
    [changeSort, trackEvent],
  );

  return (
    <div className="flex justify-between gap-2">
      <div className="flex gap-2">
        {isProductSortingEnabled && <ProductSorting onSelect={handleSortingChange} />}
        <DownloadActions />
      </div>
      <ProductsContentSwitcher />
    </div>
  );
};
